import { gql } from '@apollo/client';

const fragments = {};

fragments.internalNoteFields = gql`
  fragment InternalNoteFields on InternalNote {
    id
    author {
      id
      fullName
    }
    body
    flagged
    createdOn
  }
`;

export const CREATE_LEDGER_ACCOUNT_INTERNAL_NOTE = gql`
  mutation createLedgerAccountInternalNote($body: String!, $parentId: ID!) {
    createLedgerAccountInternalNote(internalNoteBody: $body, ledgerAccountId: $parentId) {
      id
      internalNotes {
        ...InternalNoteFields
      }
    }
  }
  ${fragments.internalNoteFields}
`;

export const UPDATE_LEDGER_ACCOUNT_INTERNAL_NOTE = gql`
  mutation updateLedgerAccountInternalNote(
    $body: String
    $flagged: Boolean
    $parentId: ID!
    $id: ID!
  ) {
    updateLedgerAccountInternalNote(
      noteId: $id
      ledgerAccountId: $parentId
      body: $body
      flagged: $flagged
    ) {
      id
      internalNotes {
        ...InternalNoteFields
      }
    }
  }
  ${fragments.internalNoteFields}
`;

export const DELETE_LEDGER_ACCOUNT_INTERNAL_NOTE = gql`
  mutation deleteLedgerAccountInternalNote($parentId: ID!, $id: ID!) {
    deleteLedgerAccountInternalNote(noteId: $id, ledgerAccountId: $parentId) {
      id
      internalNotes {
        ...InternalNoteFields
      }
    }
  }
  ${fragments.internalNoteFields}
`;

export const CREATE_JOURNAL_ENTRY_INTERNAL_NOTE = gql`
  mutation createJournalEntryInternalNote($body: String!, $parentId: ID!) {
    createJournalEntryInternalNote(internalNoteBody: $body, journalEntryId: $parentId) {
      id
      internalNotes {
        id
        author {
          id
          fullName
        }
        body
        flagged
        createdOn
      }
    }
  }
`;

export const UPDATE_JOURNAL_ENTRY_INTERNAL_NOTE = gql`
  mutation updateJournalEntryInternalNote(
    $id: ID!
    $parentId: ID!
    $body: String
    $flagged: Boolean
  ) {
    updateJournalEntryInternalNote(
      noteId: $id
      journalEntryId: $parentId
      body: $body
      flagged: $flagged
    ) {
      id
      internalNotes {
        id
        body
        flagged
      }
    }
  }
`;

export const DELETE_JOURNAL_ENTRY_INTERNAL_NOTE = gql`
  mutation deleteJournalEntryInternalNote($id: ID!, $parentId: ID!) {
    deleteJournalEntryInternalNote(noteId: $id, journalEntryId: $parentId) {
      id
      internalNotes {
        id
      }
    }
  }
`;
